export default __webpack_public_path__ + "static/media/slide2.9379746d.png";